// extracted by mini-css-extract-plugin
module.exports = {"Button":"BookmarkButton_Button__2kRXb","inactive":"BookmarkButton_inactive__m23c-","clicked":"BookmarkButton_clicked__3eHcS"};